import axios from 'axios';

var http = {};
//
['get', 'post'].map(method => {
    http[method] = (...args) => axios[method](...args).then(response => {
        if (response) {
            let data = response.data
            return data
        }
    })
})
export default http
